"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pdfMakeStyles = void 0;
exports.pdfMakeStyles = {
    tableText: {
        fontSize: 8,
        bold: false,
        margin: [-20, 15, 0, 0],
        alignment: "left"
    },
    tableTextNoMargin: {
        fontSize: 8,
        bold: false,
        margin: [0, 15, 0, 0],
        alignment: "left"
    },
    monographText: {
        fontSize: 8,
        bold: false,
        margin: [0, 15, 0, 0],
        alignment: "left"
    },
    patientReceipt: {
        fontSize: 6,
        alignment: "left",
        margin: [-20, -30, 0, 30]
    },
    patientReceiptClone: {
        fontSize: 6,
        alignment: "left"
    },
    secondRowLeft: {
        fontSize: 6,
        margin: [-20, 0, 0, 0]
    },
    rightColumn: {
        fontSize: 6,
        margin: [0, -30, -20, 0]
    },
    secondRowRight: {
        fontSize: 6,
        margin: [0, 0, -20, 50]
    },
    labelTableText: {
        margin: [0, -20, 5, 0],
        fontSize: 5,
        bold: false,
        alignment: "left"
    },
    notice: {
        fontSize: 8,
        margin: [50, 30, 0, 0],
        alignment: "center"
    },
    barcode: {
        alignment: "center"
    },
    drugInfo: {
        fontSize: 10,
        bold: true,
        margin: [0, 40, 10, 0],
        alignment: "center"
    },
    prescriberAgent: {
        fontSize: 10,
        // alignment: 'center',
        decoration: "underline",
        decorationStyle: "solid",
        decorationColor: "black"
    },
    description: {
        // alignment: 'center',
        fontSize: 8
        // margin:[-50, 5, 0, 0]
    },
    dispenseAsWritten: {
        // alignment: 'center',
        decoration: "underline",
        decorationStyle: "solid",
        decorationColor: "black"
    },
    testWidth: {
        width: 100
    },
    RxRow: {
        margin: [10, 0, 0, 0]
    },
    headerRow: {
        bold: true
    },
    rightAlign: {
        alignment: "right"
    },
    acknowledgement: {
        margin: [0, 5, 0, 40]
    },
    signature: {
        margin: [0, 0, 0, 10]
    },
    underline: {
        decoration: "underline",
        decorationStyle: "solid",
        decorationColor: "black"
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/pdfMakeStyles.ts
// module id = 2717
// module chunks = 0 1